import React, { useState, useEffect, Fragment } from "react";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import { Modal } from "react-bootstrap";
import Dropdown from "../../reusables/dropdown";
import InputField from "../../reusables/input";
import { connect } from "react-redux";
import {
  get_base_currency,
  get_countries,
  get_currencies,
  add_currency,
  edit_currency,
} from "../../../redux/actions/adminActions";
import Spinner from "../../reusables/spinner";

function Currency({
  baseCurrency,
  getBaseCurrency,
  getCountryList,
  getCurrencyList,
  currencyList,
  countries,
  accessToken,
  addCurrency,
  updateCurrency,
}) {
  const [addNew, setAddNew] = useState(false);

  const [edit, setEdit] = useState(false);

  const [base, setBase] = useState(baseCurrency);

  const [formData, setData] = useState({
    country_id: 223,
    exchange_rate: null,
    country: "United States",
    currency: null,
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleLoading = () => {
    setIsLoading(true);

    setInterval(() => {
      setIsLoading(false);
    }, 4000);
  };

  const handleSelect = (item) => {
    setData({
      ...formData,
      country_id: item.id,
      country: item.name + "(" + item.currency + ")",
      currency: item.currency,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLoading();
    addCurrency(
      formData,
      () => {
        setIsLoading(false);
        setAddNew(false);
        getCurrencyList(accessToken);
      },
      accessToken
    );
  };

  const [updatedCurrencies, setUpdate] = useState(currencyList);

  const handleEdit = (e, id) => {
    let updatedCurrency = updatedCurrencies.map((item) => {
      return item.id === id
        ? {
            ...item,
            exchange_rate: e.target.value,
          }
        : item;
    });
    setUpdate(updatedCurrency);
  };

  const handleDelete = (e, id) => {
    e.preventDefault();
    let filteredCurrencies = updatedCurrencies.filter((i) => i.id !== id);
    setUpdate(filteredCurrencies);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    let ids = [];
    let exchange_rates = [];

    updatedCurrencies.map((item) => {
      ids.push(item.id);
      exchange_rates.push(item.exchange_rate);
    });

    if (baseCurrency.exchange_rate !== base.exchange_rate) {
      ids.push(base.id);
      exchange_rates.push(base.exchange_rate);
    }

    let compiledData = {
      ids,
      exchange_rates,
    };

    updateCurrency(compiledData, updatedCurrencies, accessToken, () => {
      setEdit(false);
      getBaseCurrency(accessToken);
      getCurrencyList(accessToken);
    });
  };

  useEffect(() => {
    getBaseCurrency(accessToken);
    getCountryList(accessToken);
    getCurrencyList(accessToken);
  }, [getBaseCurrency, getCountryList, accessToken]);

  useEffect(() => {
    setUpdate(currencyList);
    setBase(baseCurrency);
  }, [currencyList, baseCurrency]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="row">
        <div className="col-lg-7">
          <div className="sectionHeight--mid">
            <div className="hasBorder--bottom pb-3">
              <p className="sectionText--small mb-1 textIsGray">
                Base Currency
              </p>
              <div className="alignOnly mt-2">
                <span className="bgGray hasRadius p-2 textIsBold sectionText px-3">
                  {base?.base_currency || base?.currency || base?.country?.currency || 'NGN'}
                </span>
                <span className="hasBorder hasRadius p-2 sectionText mr-4 px-3">
                  {base?.exchange_rate || '1.00'}
                </span>
              </div>
            </div>

            <div className="alignOnly pt-3">
              {currencyList?.length > 0 ? (
                currencyList?.map((item) => (
                  <div className="pt-2 pb-2">
                    <p className="sectionText--small mb-2 textIsGray">
                      {item?.country?.currency || item?.currency || item?.supporting_currency}
                    </p>
                    <span className="hasBorder hasRadius p-2 textIsBold sectionText mr-4 px-3">
                      {item?.exchange_rate}
                    </span>
                  </div>
                ))
              ) : (
                <div className="">
                  <h2 className="sectionText--small alignOnly mb-0">
                    Loading Currencies
                    <Spinner />
                  </h2>
                </div>
              )}

              <div className="mx-2 pt-3">
                <button
                  className="btn__transparent"
                  onClick={() => setAddNew(true)}
                >
                  <i class="ri-add-line"></i>
                  Add New
                </button>
              </div>
            </div>

            <div className="mt-4">
              {/* <button className="btn__filled hasRadius">
                                Save
                            </button> */}

              <button
                className="btn__transparent--green hasRadius mx-2"
                onClick={() => setEdit(true)}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal show={addNew} onHide={() => setAddNew(false)} centered>
        <div className="sectionHeight--mid alignOnly container p-3">
          <div
            className="icon--tiny isClickable closeModal"
            onClick={() => setAddNew(false)}
          >
            <i class="ri-close-line sectionText--small"></i>
          </div>
          <div className="w-100">
            <h2 className="sectionText--mid">Add New Cuurency</h2>

            <form onSubmit={handleSubmit}>
              <div className="mt-3 mb-3">
                <Dropdown label="Select Country" value={formData.country}>
                  {countries?.map((item) => (
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => handleSelect(item)}
                    >
                      <p className="sectionText px-3 py-2 mb-0">
                        {item.name} ({item.currency})
                      </p>
                    </div>
                  ))}
                </Dropdown>
              </div>

              <div className="mt-3 mb-3">
                <InputField
                  type="number"
                  label="Rate"
                  name="exchange_rate"
                  value={formData.exchange_rate}
                  onChange={(e) =>
                    setData({
                      ...formData,
                      exchange_rate: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mt-3">
                {isLoading ? (
                  <button className="btn__filled textIsBold alignOnly">
                    Please Wait {""}
                    <Spinner />
                  </button>
                ) : (
                  <button className="btn__filled">Add</button>
                )}
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <Modal show={edit} onHide={() => setEdit(false)} centered>
        <div className="sectionHeight--mid alignOnly container p-3">
          <div
            className="icon--tiny isClickable closeModal"
            onClick={() => setAddNew(false)}
          >
            <i class="ri-close-line sectionText--small"></i>
          </div>
          <div className="w-100 p-4">
            {updatedCurrencies?.length > 0 ? (
              <form>
                {updatedCurrencies?.map((item) => (
                  <div className="pt-2 pb-2 spaceBetween edit">
                    <Fragment>
                      <div className="hasBorder hasRadius py-2 textIsBold sectionText mx-2 px-3">
                        {item?.country?.currency || item?.currency || item?.supporting_currency}
                      </div>

                      <div className="w-30">
                        <InputField
                          name="exchange_rate"
                          value={item?.exchange_rate}
                          onChange={(e) => handleEdit(e, item?.id)}
                        />
                      </div>
                      <div className="">
                        {item?.is_base ? (
                          <button
                            className={`hasRadius btn__disabled disabled`}
                            disabled
                          >
                            Delete
                          </button>
                        ) : (
                          <button
                            className={`btn__red hasRadius`}
                            onClick={(e) => handleDelete(e, item?.id)}
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </Fragment>
                  </div>
                ))}
                <div
                  className="btn__filled hasRadius w-100 my-4 isClickable"
                  onClick={handleUpdate}
                >
                  Save
                </div>
              </form>
            ) : (
              <div className="">
                <h2 className="sectionText--small center mb-0">
                  No currency found
                </h2>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  baseCurrency: state.admin.baseCurrency,
  currencyList: state.admin.currencies,
  countries: state.admin.countries,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getBaseCurrency: (token) => dispatch(get_base_currency(token)),
  getCountryList: (token) => dispatch(get_countries(token)),
  getCurrencyList: (token) => dispatch(get_currencies(token)),
  addCurrency: (data, success, token) =>
    dispatch(add_currency(data, success, token)),
  updateCurrency: (data, updatedCurrency, token, success) =>
    dispatch(edit_currency(data, updatedCurrency, token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Currency);
